/**
 * HeroUI DataGrid 行操作列 id（勿与表字段 `actions` 等重名，否则会触发 RAC「列数与单元格数不一致」）。
 */
export const PAGE_DATA_GRID_ROW_ACTIONS_COLUMN_ID = '__row_actions';

/**
 * 与后端 MetaProjector 生成的 table 场景字段对齐（子集，供列构建使用）
 */
export type PageDataGridTableFieldMeta = {
  fieldName: string;
  label: string;
  sortable?: boolean;
  /** Query 维度：与 Table Schema 中 `meta.filterable` 对齐（table 场景由 MetaProjector 投影） */
  filterable?: boolean;
  /** Query 维度：与 Table Schema 中 `meta.searchable` 对齐 */
  searchable?: boolean;
  /** 与 MetaProjector / schema 的 `columnComponent` 对齐 */
  columnComponent?: string;
  /** 与枚举项顺序对应的 Badge 等变体 */
  variants?: string[];
  /** 列最小宽度（px），与 Table Schema `columnMinWidth` / DataGrid `minWidth` 对齐 */
  columnMinWidth?: number;
  /**
   * 是否默认在表格中显示；`false` 时首屏不显示（用户可通过「列显示」打开）。
   * 未设置时视为 true。
   */
  columnVisible?: boolean;
  options?: Array<{
    value: string;
    label: string;
    description?: string;
    disabled?: boolean;
    color?: string;
  }>;
};

export type PageDataGridTableMeta = {
  scene: string;
  fields: PageDataGridTableFieldMeta[];
};

export function isPageDataGridTableMeta(x: unknown): x is PageDataGridTableMeta {
  if (typeof x !== 'object' || x === null) return false;
  const o = x as Record<string, unknown>;
  return o.scene === 'table' && Array.isArray(o.fields);
}
